import svgConnect from "../../../../assets/imgs/socials/connects/twitter.svg";
import svgNaoConectado from "../../../../assets/imgs/socials/notConnects/twitter.svg";

import MyImage from "../../../myImage"

const MyIconTwitter = ({sx, connect}) =><MyImage src={connect ? svgConnect : svgNaoConectado} alt={'twitter icon'} sx={sx} />

export default MyIconTwitter;
